import { PayloadAction } from "@reduxjs/toolkit";
import { ClientsState } from "../../models/ClientsState";

const downloadClientsTemplateFetch = (state: ClientsState, action: PayloadAction) => {
    state.isLoading = true;
}

export default downloadClientsTemplateFetch;